import LanguageAdornment from './LanguageAdornment';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles } from './style/gstheme';
import PropTypes from 'prop-types';
import LockIcon from '@material-ui/icons/Lock';

const styles = Object.assign({}, globalStyles);

class BasicReadField extends React.PureComponent {

    render() {

        const { classes, margin, text, label, fullWidth, locked, dataTest, disabled, multiline, lang, rows, fontFamily } = this.props;
        const icon = locked ? <LockIcon style={{ color: '#9e9e9e' }} /> : null;
        const styleClass = locked ? classes.basicReadField : classes.inputLabel;

        return (
            <TextField
                margin={margin}
                value={text}
                variant="outlined"
                label={label}
                multiline={multiline}
                minRows={rows}
                maxRows={rows}
                fullWidth={fullWidth}
                style={{
                    marginTop: '0px'
                }}
                InputProps={{
                    inputProps: {
                        "data-test": dataTest,
                        ...(disabled) && {
                            "style": {
                                backgroundColor: '#f0f0f0'
                            }
                        },
                        "style": {
                            ...(fontFamily) && { fontFamily }
                        }
                    },
                    className: styleClass,
                    classes: {
                        input: styleClass
                    },
                    readOnly: true,
                    startAdornment: lang ? (<LanguageAdornment lang={lang} />) : null,
                    endAdornment: icon
                }} />
        );
    }
}

BasicReadField.defaultProps = {
    margin: "dense",
    fullWidth: false,
    locked: false,
    multiline: false,
    disabled: false,
    rows: 3,
    lang: null
};

BasicReadField.propTypes = {
    dataTest: PropTypes.string,
    fontFamily: PropTypes.string,
    disabled: PropTypes.bool,
    lang: PropTypes.string,
    rows: PropTypes.number,
    margin: PropTypes.oneOf(['normal', 'dense']),
    text: PropTypes.string.isRequired,
    multiline: PropTypes.bool,
    locked: PropTypes.bool,
    label: PropTypes.string,
    fullWidth: PropTypes.bool,
    classes: PropTypes.object
};

export default withStyles(styles)(BasicReadField);